import * as v from "valibot";

// request
export const RequestSchema = v.object({
  AddonId: v.string(),
  ClusterId: v.string(),
  // ClusterName: v.string(),
  InstanceId: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  AddonId: v.nullish(v.string()),
  ClusterId: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
});
export type Response = v.InferOutput<typeof ResponseSchema>;
